"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasShortName = void 0;
const types_1 = require("../../../../containers/ConfigProvider/types");
const MOBILE_DEVICES = new Set([
    types_1.EClientTypes.WEB_MOBILE,
    types_1.EClientTypes.NATIVE_IOS,
    types_1.EClientTypes.NATIVE_ANDROID,
]);
const hasShortName = (market, clientType) => {
    return MOBILE_DEVICES.has(clientType)
        ? market.outcomesGroup.shortNamedMobile
        : market.outcomesGroup.shortNamed;
};
exports.hasShortName = hasShortName;
//# sourceMappingURL=hasShortName.js.map